/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AddEstimationGroupMeteringPointsCommand } from '../model/addEstimationGroupMeteringPointsCommand';
// @ts-ignore
import { EstimationGroupMeteringPointSearchQuery } from '../model/estimationGroupMeteringPointSearchQuery';
// @ts-ignore
import { PagedResultOfEstimationGroupMeteringPointSearchResult } from '../model/pagedResultOfEstimationGroupMeteringPointSearchResult';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class EstimationGroupMeteringPointsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /vee/estimationgroups/{estimationGroupId}/meteringpoints
     * @param estimationGroupId 
     * @param addEstimationGroupMeteringPointsCommand 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public veeEstimationgroupsEstimationGroupIdMeteringpointsPost(estimationGroupId: string, addEstimationGroupMeteringPointsCommand: AddEstimationGroupMeteringPointsCommand, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public veeEstimationgroupsEstimationGroupIdMeteringpointsPost(estimationGroupId: string, addEstimationGroupMeteringPointsCommand: AddEstimationGroupMeteringPointsCommand, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public veeEstimationgroupsEstimationGroupIdMeteringpointsPost(estimationGroupId: string, addEstimationGroupMeteringPointsCommand: AddEstimationGroupMeteringPointsCommand, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public veeEstimationgroupsEstimationGroupIdMeteringpointsPost(estimationGroupId: string, addEstimationGroupMeteringPointsCommand: AddEstimationGroupMeteringPointsCommand, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (estimationGroupId === null || estimationGroupId === undefined) {
            throw new Error('Required parameter estimationGroupId was null or undefined when calling veeEstimationgroupsEstimationGroupIdMeteringpointsPost.');
        }
        if (addEstimationGroupMeteringPointsCommand === null || addEstimationGroupMeteringPointsCommand === undefined) {
            throw new Error('Required parameter addEstimationGroupMeteringPointsCommand was null or undefined when calling veeEstimationgroupsEstimationGroupIdMeteringpointsPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vee/estimationgroups/${this.configuration.encodeParam({name: "estimationGroupId", value: estimationGroupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/meteringpoints`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: addEstimationGroupMeteringPointsCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /vee/estimationgroups/{estimationGroupId}/meteringpoints/search
     * @param estimationGroupId 
     * @param estimationGroupMeteringPointSearchQuery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public veeEstimationgroupsEstimationGroupIdMeteringpointsSearchPost(estimationGroupId: string, estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedResultOfEstimationGroupMeteringPointSearchResult>;
    public veeEstimationgroupsEstimationGroupIdMeteringpointsSearchPost(estimationGroupId: string, estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedResultOfEstimationGroupMeteringPointSearchResult>>;
    public veeEstimationgroupsEstimationGroupIdMeteringpointsSearchPost(estimationGroupId: string, estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedResultOfEstimationGroupMeteringPointSearchResult>>;
    public veeEstimationgroupsEstimationGroupIdMeteringpointsSearchPost(estimationGroupId: string, estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (estimationGroupId === null || estimationGroupId === undefined) {
            throw new Error('Required parameter estimationGroupId was null or undefined when calling veeEstimationgroupsEstimationGroupIdMeteringpointsSearchPost.');
        }
        if (estimationGroupMeteringPointSearchQuery === null || estimationGroupMeteringPointSearchQuery === undefined) {
            throw new Error('Required parameter estimationGroupMeteringPointSearchQuery was null or undefined when calling veeEstimationgroupsEstimationGroupIdMeteringpointsSearchPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vee/estimationgroups/${this.configuration.encodeParam({name: "estimationGroupId", value: estimationGroupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/meteringpoints/search`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedResultOfEstimationGroupMeteringPointSearchResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: estimationGroupMeteringPointSearchQuery,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
